import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        company: '=',
        form: '=',
        countries: '='
    },
    template: `
        <div class="well">
            <div class="heading01"><h2>{{ 'company.General data' | translate }}</h2></div>
            <form class="form" ng-submit="vm.save()">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'company.Name' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.name" type="text" class="form-control"
                            ng-readonly="vm.form.model.id === vm.TokenService.getCompanyId()">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row ng-if="!vm.form.model.id" error="vm.form.errors.email">
                        <label class="label">{{ 'company.Admin email' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.email" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.timezone">
                        <label class="label">{{ 'company.Company timezone' | translate }} *</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <select class="form-control" ng-model="vm.form.model.timezone">
                                <option
                                    ng-repeat="(timezone, label) in vm.TIMEZONE_ENUM.LABELS"
                                    value="{{ vm.TIMEZONE_ENUM.KEYS[timezone] }}">
                                    {{ label }}
                                </option>
                            </select>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.defaultCountry">
                        <label class="label">{{ 'company.Company default country' | translate }}</label>
                        <div class="items">
                            <ui-select ng-model="vm.form.model.defaultCountry" theme="selectize" title="{{ 'company.Country' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a country in the list...' | translate }}"
                                >{{$select.selected.label}}</ui-select-match>
                                <ui-select-choices repeat="country.key as country in vm.countries | filter: $select.search">
                                    <span ng-bind-html="country.label | highlight: $select.search"></span>
                                </ui-select-choices>
                            </ui-select>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.systemEmail">
                        <label class="label">{{ 'company.System email' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.form.model.systemEmail" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.systemEmailName">
                        <label class="label">{{ 'company.System email name' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.form.model.systemEmailName" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.skin">
                        <label class="label">{{ 'company.Skin' | translate }}</label>
                        <div class="items">
                          <form-row-error></form-row-error>
                          <select class="form-control"
                                  ng-model="vm.form.model.skin"
                                  ng-options="skin as label for (skin, label) in vm.COMPANY_SKIN_ENUM.LABELS">
                          </select>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.languages">
                        <label class="label">{{ 'company.Company languages' | translate }} *</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ul ng-repeat="(lang, label) in vm.COMPANY_LANGUAGE_ENUM.LABELS" class="checkboxes">
                                <li>
                                    <label> {{ vm.COMPANY_LANGUAGE_ENUM.LABELS[lang] }}
                                        <input
                                            type="checkbox"
                                            ng-checked="vm.lodash.includes(vm.form.model.languages, lang)"
                                            ng-click="vm.updateLanguages(lang)">
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.defaultLanguage">
                        <label class="label">
                            {{ 'company.Language' | translate }} *
                            <small>{{ 'company.NB! Value can not be changed through UI after initial insert' | translate }}</small>
                        </label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <select class="form-control"
                                    ng-model="vm.form.model.defaultLanguage"
                                    ng-disabled="vm.form.model.id"
                                    ng-options="language as label for (language, label) in vm.COMPANY_LANGUAGE_ENUM.LABELS">
                            </select>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.adminDefaultLanguage">
                        <label class="label">{{ 'company.Admin UI default language' | translate }} *</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <select class="form-control"
                                    ng-model="vm.form.model.adminDefaultLanguage"
                                    ng-options="language as label for (language, label) in vm.COMPANY_ADMIN_LANGUAGE_ENUM.LABELS">
                            </select>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.externalWpUrl">
                        <label class="label">{{ 'company.External portal url' | translate }}</label>
                        <div class="items">
                            <input type="text" class="form-control" ng-model="vm.form.model.externalWpUrl">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.syncUsersToExternalWp">
                        <label class="label">{{ 'company.Sync users to external portal' | translate }}</label>
                        <div class="items">
                            <input type="checkbox" ng-model="vm.form.model.syncUsersToExternalWp">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isFormModuleEnabled">
                        <label class="label">{{ 'company.Forms module enabled' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <input type="checkbox" ng-model="vm.form.model.isFormModuleEnabled" />
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isFormEvaluationModuleEnabled">
                        <label class="label">{{ 'company.Forms 360 feedback module enabled' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <input type="checkbox" ng-model="vm.form.model.isFormEvaluationModuleEnabled" />
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isFormSurveyModuleEnabled">
                        <label class="label">{{ 'company.Forms survey module enabled' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <input type="checkbox" ng-model="vm.form.model.isFormSurveyModuleEnabled" />
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isPerformanceReviewModuleEnabled">
                        <label class="label">{{ 'company.Performance review module enabled' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <input type="checkbox" ng-model="vm.form.model.isPerformanceReviewModuleEnabled" />
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isLicencePointsModuleEnabled">
                        <label class="label">{{ 'company.Licence points module' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <input type="checkbox" ng-model="vm.form.model.isLicencePointsModuleEnabled" />
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isScormCloudEnabled">
                        <label class="label">{{ 'company.Is scorm cloud enabled' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isScormCloudEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row ng-if="vm.form.model.isScormCloudEnabled" error="vm.form.errors.scormCloudAppId">
                        <label class="label">{{ 'company.Scorm cloud app id' | translate}}</label>
                        <div class="items">
                           <input type="text" class="form-control" ng-model="vm.form.model.scormCloudAppId">
                           <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row ng-if="vm.form.model.isScormCloudEnabled" >
                        <label class="label">{{ 'company.Scorm cloud app secret key' | translate}}</label>
                        <div class="items">
                             <input type="text" class="form-control" ng-model="vm.form.model.scormCloudAppSecretKey">
                             <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isOptionalCoursesModuleEnabled">
                        <label class="label">{{ 'company.Is optional course module enabled' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isOptionalCoursesModuleEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isBudgetModuleEnabled">
                        <label class="label">{{ 'company.Is budget module enabled' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isBudgetModuleEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isCompetencesModuleEnabled">
                        <label class="label">{{ 'company.Is competences and skills module enabled' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isCompetencesModuleEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isExternalParticipationModuleEnabled">
                        <label class="label">{{ 'company.External participations module' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isExternalParticipationModuleEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isEventsModuleEnabled">
                        <label class="label">{{ 'company.Events module' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isEventsModuleEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isGuidanceModuleEnabled">
                        <label class="label">{{ 'company.Guidance module' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isGuidanceModuleEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isWebinarModuleEnabled">
                        <label class="label">{{ 'company.Is webinar module enabled' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isWebinarModuleEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isTasklistModuleEnabled">
                        <label class="label">{{ 'company.Is tasklist module enabled' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isTasklistModuleEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isAnalyticsModuleEnabled">
                        <label class="label">{{ 'company.Analytics module' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isAnalyticsModuleEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isSkillsModuleEnabled">
                        <label class="label">{{ 'company.Skills module' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isSkillsModuleEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isTrainingCompany">
                        <label class="label">{{ 'company.Training company' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isTrainingCompany" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row ng-if="vm.form.model.isTrainingCompany" error="vm.form.errors.trainingMarketplaceUrl">
                        <label class="label">{{ 'company.Training marketplace URL' | translate}}</label>
                        <div class="items">
                            <input ng-model="vm.form.model.trainingMarketplaceUrl" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.autoAddUsersToTrainingTimes">
                        <label class="label">{{ 'company.Automatically add employees to training time' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.autoAddUsersToTrainingTimes" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.siteAccessForAllSites">
                        <label class="label">{{ 'company.access_for_all_sites' | translate }} *</label>
                        <div class="items">
                            <ul class="checkboxes">
                                <li ng-repeat="(key,value) in vm.COMPANY_SITE_ACCESS_ENUM.LABELS">
                                    <label>
                                        <input
                                            type="radio"
                                            ng-model="vm.form.model.siteAccessForAllSites"
                                            name="siteAccessForAllSites"
                                            ng-value="key"/>
                                        {{ value }}
                                    </label>
                                </li>
                            </ul>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isExternalParticipationSimpleRequestEnabled">
                        <label class="label">{{ 'company.Enable simple training requests' | translate}}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <label>
                                <input ng-model="vm.form.model.isExternalParticipationSimpleRequestEnabled" type="checkbox">
                            </label>
                        </div>
                    </form-row>
                </form-wrapper>
                <button ng-if="!vm.form.model.id || vm.form.model.id != vm.TokenService.getCompanyId()" type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
            </form>
            <ul class="actions01">
                <li class="primary">
                    <a ng-click="vm.save()" class="btn main">
                        <span ng-if="vm.form.model.id">{{ 'general.Save' | translate }}</span>
                        <span ng-if="!vm.form.model.id">{{ 'manage.Add company' | translate }}</span>
                    </a>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($state, $translate, toastr, lodash, TokenService,
                 COMPANY_SKIN_ENUM, COMPANY_LANGUAGE_ENUM, COMPANY_ADMIN_LANGUAGE_ENUM, TIMEZONE_ENUM, COMPANY_SITE_ACCESS_ENUM) {
        this.$state = $state;
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.COMPANY_SKIN_ENUM = COMPANY_SKIN_ENUM;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.COMPANY_ADMIN_LANGUAGE_ENUM = COMPANY_ADMIN_LANGUAGE_ENUM;
        this.TIMEZONE_ENUM = TIMEZONE_ENUM;
        this.COMPANY_SITE_ACCESS_ENUM = COMPANY_SITE_ACCESS_ENUM;
    }

    $onInit () {
        this.form.model.timezone = this.form.model.timezone ? this.form.model.timezone : this.TIMEZONE_ENUM.KEYS.EUROPE_TALLINN;
        // convert value into boolean
        this.form.model.syncUsersToExternalWp = this.form.model.syncUsersToExternalWp === 1;
        this.form.model.autoAddUsersToTrainingTimes = this.form.model.autoAddUsersToTrainingTimes === 1;

        this.form.model.defaultLanguage = this.form.model.defaultLanguage || this.COMPANY_LANGUAGE_ENUM.KEYS.ET;
        this.form.model.languages = this.form.model.languages ? this.form.model.languages.map(item => item.language) : [];
    }

    save () {
        this.form.save().then(() => {
            this.toastr.success(this.$translate.instant('general.Changes saved'));
            this.$state.go('authorized.manage.permissions.companies.list');
        });
    }

    updateLanguages (language) {
        if (this.lodash.includes(this.form.model.languages, language)) {
            this.lodash.pull(this.form.model.languages, language);
        }
        else {
            this.form.model.languages.push(language);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/companies/form/generalData/index.js